import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {tap, finalize, timeout} from 'rxjs/operators';
import {LoaderService} from '../loader.service';
import {SessionService} from '../session.service';
import {Constants} from '../../components/common/constants';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../../environments/environment';
import { EncryptServiceService } from '../encrypt-service/encrypt-service.service';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
    timerSub;
    secondTicks: number;
    defaultTimeout = 300000;
    countRequests = 0;
    requestClone: any;

    constructor(
        private loaderService: LoaderService,
        private sessionService: SessionService,
        private _encryptService:EncryptServiceService,
    ) {
    }

    getRequest(body): string {
        const key = CryptoJS.enc.Utf8.parse(Constants.KEY);
        return CryptoJS.AES.encrypt(JSON.stringify(body), key,
            {keySize: 16, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString();
    }

    getRequestObfuscate(index, body): string {
        let bodyAux = '';
        for (let i = 0; i < body.length; i++) {
            bodyAux += String.fromCharCode(body.charCodeAt(i) - index);
        }
        return bodyAux;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): any {
        this.requestClone = null;
        if (req.headers.get('withoutTimer')) {
            req.headers.delete('withoutTimer');
        } else {
            this.loaderService.showLoader();
            this.countRequests++;
        }
        let headers = req.headers;
        const authData = this.sessionService.getAuthData();
        if (!req.url.includes(Constants.endpoints.createAccount) && !req.url.includes(Constants.endpoints.resetPassword)
            && !req.url.includes(Constants.endpoints.sendOrder) && !req.url.includes(Constants.endpoints.login)
            && !req.url.includes(Constants.endpoints.validEmail) && !req.url.includes(Constants.endpoints.changePassword)
            && !req.url.includes(Constants.endpoints.register) && !req.url.includes(Constants.endpoints.infoUser)
            && !req.url.includes(this._encryptService.decryptData(environment.SERVER_URL_POSITION)) && !req.url.includes(this._encryptService.decryptData(environment.SERVER_URL_LOCALIZATION))
            && !req.url.includes(Constants.endpoints.checkCode) && !req.url.includes(Constants.endpoints.checkMovil)) {
            headers = headers.append(
                'Authorization',
                `Bearer ${authData.access_token}`
            );
        } else {
            switch (true) {
                case (req.url.includes(Constants.endpoints.login)):
                    headers = headers.append('Authorization', 'Basic ZmFkOmZhZHNlY3JldA==');
                    break;
            }
            if (authData) {
                switch (true) {
                    case (req.url.includes(Constants.endpoints.infoUser)):
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        break;
                    case (req.url.includes(Constants.endpoints.validEmail)):
                        const SHA256M1 = CryptoJS.SHA256(this.getRequest(req.body)).toString();
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        headers = headers.append(Constants.HEADERS[1], this.getRequestObfuscate(1, SHA256M1));
                        this.requestClone = req.clone({headers});
                        this.requestClone.body = this.getRequest(req.body);
                        break;
                    case (req.url.includes(Constants.endpoints.register)):
                        const SHA256M3 = CryptoJS.SHA256(this.getRequest(req.body)).toString();
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        headers = headers.append(Constants.HEADERS[1], this.getRequestObfuscate(1, SHA256M3));
                        this.requestClone = req.clone({headers});
                        this.requestClone.body = this.getRequest(req.body);
                        break;
                    case (req.url.includes(Constants.endpoints.checkMovil)):
                        const SHA256M8 = CryptoJS.SHA256(this.getRequest(req.body)).toString();
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        headers = headers.append(Constants.HEADERS[1], this.getRequestObfuscate(1, SHA256M8));
                        this.requestClone = req.clone({headers});
                        this.requestClone.body = this.getRequest(req.body);
                        break;
                    case (req.url.includes(Constants.endpoints.checkCode)):
                        const SHA256M2 = CryptoJS.SHA256(this.getRequest(req.body)).toString();
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        headers = headers.append(Constants.HEADERS[1], this.getRequestObfuscate(1, SHA256M2));
                        this.requestClone = req.clone({headers});
                        this.requestClone.body = this.getRequest(req.body);
                        break;
                    case (req.url.includes(Constants.endpoints.resetPassword)):
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        break;
                    case (req.url.includes(Constants.endpoints.createAccount)):
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        break;
                    case (req.url.includes(Constants.endpoints.changePassword)):
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        break;
                    case (req.url.includes(Constants.endpoints.sendOrder)):
                        const SHA256 = CryptoJS.SHA256(this.getRequest(req.body)).toString();
                        headers = headers.append(
                            'Authorization',
                            `Bearer ${this.sessionService.getAuthData().access_token}`
                        );
                        headers = headers.append(Constants.HEADERS[0], this.getRequestObfuscate(0, SHA256));
                        headers = headers.append(Constants.HEADERS[1], this.getRequestObfuscate(1, SHA256));
                        headers = headers.append(Constants.HEADERS[2], this.getRequestObfuscate(2, SHA256));
                        headers = headers.append(Constants.HEADERS[3], this.getRequestObfuscate(3, SHA256));
                        headers = headers.append(Constants.HEADERS[4], this.getRequestObfuscate(4, SHA256));
                        this.requestClone = req.clone({headers});
                        this.requestClone.body = this.getRequest(req.body);
                        break;
                }
            } else {
                this.loaderService.hideLoader();
            }
        }

        const authReq = req.clone({headers});
        return next.handle(this.requestClone ? this.requestClone : authReq).pipe(
            tap(
                () => {
                },
                () => {
                }
            ),
            timeout(this.getTime(req)),
            finalize(() => {
                this.countRequests--;
                if (this.countRequests < 0) {
                    this.countRequests = 0;
                }
                if (this.countRequests === 0) {
                    this.loaderService.hideLoader();
                }
            })
        );
    }

    getTime(req): number {
        return this.defaultTimeout;
    }
}
